// extracted by mini-css-extract-plugin
module.exports = {"container":"ReturnIconButton-container-IpE+p","text":"ReturnIconButton-text-JXtcF"};